import { Link } from "react-router-dom";

interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
}

interface CategoryTabsProps {
  categories: Category[];
  activeCategory: string;
  variant?: "pill" | "card";
}

export default function CategoryTabs({
  categories,
  activeCategory,
  variant = "pill",
}: CategoryTabsProps) {
  if (variant === "card") {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.slug}`}
            className={`flex flex-col items-center gap-2 p-4 rounded-lg transition-all duration-200 cursor-pointer ${
              activeCategory === cat.slug
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-background-200"
            }`}
          >
            <div className="w-10 h-10 flex items-center justify-center">
              <i className={`${cat.icon} text-xl`}></i>
            </div>
            <span className="text-sm font-medium whitespace-nowrap">{cat.name}</span>
          </Link>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      {categories.map((cat) => (
        <Link
          key={cat.id}
          to={`/category/${cat.slug}`}
          className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
            activeCategory === cat.slug
              ? "bg-primary-500 text-background-50"
              : "bg-background-100 text-foreground-600 hover:bg-background-200"
          }`}
        >
          {cat.name}
        </Link>
      ))}
    </div>
  );
}